import { actionsUpdated } from 'actions/actions';
import { processMessages } from 'actions/app';
import * as StoryletActionTypes from 'actiontypes/storylet';
import StoryletService from 'services/StoryletService';
import IStoryletService from 'types/storylet/service';
import { shouldFetch as shouldFetchOpportunityCards } from 'actions/cards/fetch';

export const sendSocialInviteRequested = () => (
  {
    type: StoryletActionTypes.SEND_SOCIAL_INVITATION_REQUESTED,
  }
);

export const sendSocialInviteSuccess = (data: any) => ({
  type: StoryletActionTypes.SEND_SOCIAL_INVITATION_SUCCESS,
  payload: {
    phase: data.phase,
    endStorylet: data.endStorylet,
    externalSocialAct: data.externalSocialAct,
    messages: data.messages,
  },
});

export const sendSocialInviteFailure = (error: any) => ({
  type: StoryletActionTypes.SEND_SOCIAL_INVITATION_FAILURE,
  error: true,
  status: error.response && error.response.status,
});

export default sendSocialInvite(new StoryletService());

export function sendSocialInvite(service: IStoryletService) {
  return (invitation: any) => async (dispatch: Function) => {
    dispatch(sendSocialInviteRequested());
    try {
      const { data } = await service.sendSocialInvite(invitation);
      dispatch(sendSocialInviteSuccess(data));

      // Update actions
      dispatch(actionsUpdated(data));

      // We also need to set card state to dirty so that we'll update later
      dispatch(shouldFetchOpportunityCards());

      // If we have some result messages with quality changes, then
      // process them
      const { messages } = data;
      if (messages) {
        dispatch(processMessages(messages));
      }
      return data;
    } catch (error) {
      console.error(error);
      dispatch(sendSocialInviteFailure(error));
      return error;
    }
  };
}